(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["r2t-pa-chooser"] && !Shopify.designMode) return;
  try {
    (function () {
    const roots = document.querySelectorAll('[data-chooser-root]');
    if (!roots.length) return;

    roots.forEach(initChooser);

    function initChooser(root) {
      const selects = root.querySelectorAll('.r2t-chooser__select');
      const submitBtn = root.querySelector('[data-chooser-submit]');
      const resetBtn = root.querySelector('[data-chooser-reset]');
      const panel = root.querySelector('[data-chooser-panel]');
      const results = root.querySelector('[data-chooser-results]');
      const advice = root.querySelector('[data-chooser-advice]');
      const countEl = root.querySelector('[data-chooser-count]');
      const emptyEl = root.querySelector('[data-chooser-empty]');
      const products = root.querySelectorAll('.r2t-chooser__product');

      function getAnswers() {
        const a = {};
        selects.forEach(s => {
          const v = s.value.trim();
          if (v) a[s.dataset.q] = v;
          s.toggleAttribute('data-active', !!v);
        });
        return a;
      }

      /* Generic guidance text — never names a specific SKU. The matched
         product card grid below is the authoritative "which product"
         answer; this block tells the customer WHAT KIND of setup their
         answers point to and why. */
      function buildAdviceText(a) {
        if (Object.keys(a).length === 0) return '';
        const parts = [];

        if (a.q1 === 'transportation') {
          if (a.q2 === 'dual-mic') {
            parts.push('For <strong>transportation</strong> with 2 mics, you need a 2-mic PA unit paired with a PTT (push to talk) hand mic or headset mic for in-cabin announcements.');
          } else {
            parts.push('For <strong>transportation</strong>, you need a base PA unit paired with a PTT (push to talk) hand mic or headset mic for in-cabin announcements.');
          }
        } else if (a.q1 === 'tourism') {
          if (a.q2 === 'dual-mic') {
            parts.push('For <strong>tourism</strong> with 2 mics or on-tour music, you need a dual-input PA with variable music muting — so the music ducks but stays audible when the mic is in use.');
          } else if (a.q2 === 'single-mic') {
            parts.push('For <strong>tourism</strong> with a single mic, a base PA is the right fit — 1 mic socket, music mutes 100% when the mic is on.');
          } else {
            parts.push('For <strong>tourism</strong>, both a base and a dual-input PA can fit — answer Q2 to narrow it down.');
          }
        }

        if (a.q3 === 'oem') {
          parts.push('Your vehicle has an <strong>OEM stereo</strong> — a vehicle-specific installation T-harness gives a plug-and-play install with no wire cutting. <strong>Contact us for your vehicle-specific OEM harness availability.</strong>');
        } else if (a.q3 === 'aftermarket') {
          parts.push('You have an <strong>aftermarket stereo</strong> — the PA connects via the included cables. For specific aftermarket head units, an ISO T-harness may be required. <strong>Contact us to confirm what fits your head unit.</strong>');
        }

        return parts.join(' ');
      }

      function productMatches(product, a) {
        const tags = (product.dataset.tags || '').toLowerCase();
        for (const q in a) {
          const selected = a[q];
          const matchTag = 'chooser-' + q + '-' + selected;
          const anyTag = 'chooser-' + q + '-any';
          if (!tags.includes(matchTag) && !tags.includes(anyTag)) {
            return false;
          }
        }
        return true;
      }

      function showResults() {
        const a = getAnswers();
        const adviceText = buildAdviceText(a);

        if (Object.keys(a).length === 0) {
          panel.hidden = true;
          return;
        }
        panel.hidden = false;

        if (advice) {
          advice.innerHTML = adviceText;
          advice.style.display = adviceText ? '' : 'none';
        }

        let count = 0;
        products.forEach(p => {
          const match = productMatches(p, a);
          p.hidden = !match;
          if (match) count++;
        });
        if (countEl) {
          countEl.textContent = count + (count === 1 ? ' product' : ' products');
        }
        if (emptyEl) emptyEl.hidden = count > 0;

        try {
          panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } catch (e) { /* older browsers */ }
      }

      function reset() {
        selects.forEach(s => { s.value = ''; s.removeAttribute('data-active'); });
        if (panel) panel.hidden = true;
        products.forEach(p => p.hidden = false);
      }

      if (submitBtn) submitBtn.addEventListener('click', showResults);
      if (resetBtn) resetBtn.addEventListener('click', reset);
      selects.forEach(s => s.addEventListener('change', function () {
        s.toggleAttribute('data-active', !!s.value);
      }));
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
